import { Chip, Stack, Typography } from "@mui/material"
import { ListItemBox } from "lib/@components/ListItemBox"
import { If } from "lib/@components/switch"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { buildExpandedContentPreview } from "../lib/amends-content-preview"
import { hasAmendsContent } from "../lib/amends-content"
import { hasAudienceAmendsContent, normalizeAudienceAmends } from "../lib/audience-aware-amends.mjs"

export function AuthoringAmendsAuditContent({ payload }) {
    const { macroMap } = useBoundContext()
    const note = normalizeAudienceAmends(payload)
    const { taskTitle } = payload ?? {}
    const label = payload?.label ?? "Author Note"
    const hideTaskTitle = payload?.hideTaskTitle === true
    const isNewTask = payload?.isNewTask === true
    if (!hasAudienceAmendsContent(note)) return null

    return (
        <Stack spacing={0.5} sx={{ mb: 1 }}>
            <If truthy={!hideTaskTitle && isNewTask && taskTitle}>
                <Typography>{taskTitle}</Typography>
            </If>
            <ListItemBox spacing={0.5} alignItems="center">
                <Typography variant="subtitle2">{label}</Typography>
                <If value={note.isSplit}>
                    <Chip label="Split" size="small" color="info" variant="outlined" />
                </If>
            </ListItemBox>
            <If value={note.isSplit}>
                <>
                    <Typography variant="caption" sx={{ color: "text.secondary" }}>
                        Internal
                    </Typography>
                    <Typography variant="body2" sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                        {buildPreview(note.internalContent, macroMap)}
                    </Typography>
                    <Typography variant="caption" sx={{ color: "text.secondary", mt: 0.5 }}>
                        External
                    </Typography>
                    <Typography variant="body2" sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                        {buildPreview(note.externalContent, macroMap)}
                    </Typography>
                </>
            </If>
            <If value={!note.isSplit}>
                <Typography variant="body2" sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                    {buildPreview(note.content, macroMap)}
                </Typography>
            </If>
        </Stack>
    )
}

function buildPreview(content, macroMap) {
    if (!hasAmendsContent(content)) return "No content"
    return buildExpandedContentPreview(content, macroMap)
}
